module.exports = __webpack_public_path__ + "img/sankaku_50_blue.24b23909.png";